'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout             from '@Layout/BackOffice'
import CreationForm       from '@/Form/CreationForm'
import { form as _config } from '@Config/Catalog/partner'

const config = _.cloneDeep(_config);

delete config.fields.send_notifications;

const { app } = window;

export default class NewPartnerPage extends Component
{
	constructor (props)
	{
		super(props);
	}

	UNSAFE_componentWillMount ()
	{
		var component = this;

		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		var output =
		(
			<Layout page_title="Nouveau partenaire" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<CreationForm config={ config } />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
